import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

// --safe-top 은 web globals.css 가 정의한다 — 없는 앱(admin)에서는 0.
const TOP_OFFSET = "calc(56px + var(--safe-top, 0px))";

/** 화면 위 가운데 알림(sonner) — `apps/web/src/app/layout.tsx` 에 한 번만 두고 화면에서는 `toast.success`·`toast.error` 만 부른다 · 성공은 과거형(「발송했습니다」) · 실패는 「~하지 못했습니다」 + 할 일 한 줄 · 서버 오류는 함수가 올린 한국어(P0001) 문구만 보이고 코드(23505·42501)·영문 원문은 보이지 않는다 · 되돌릴 수 없는 일의 확인은 토스트가 아니라 ConfirmDialog. */
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      className="toaster group"
      // 아래쪽에 뜨면 바닥 저장 줄·저장 버튼을 덮어 클릭을 먹는다 — 위 가운데, 셸 머리(h-12=48px)와 상태바(--safe-top, 앱 껍데기·노치) 아래로.
      mobileOffset={{ top: TOP_OFFSET }}
      offset={{ top: TOP_OFFSET }}
      position="top-center"
      theme={theme as ToasterProps["theme"]}
      // 낭독 이름 — Sonner 기본값(Notifications·Close toast)은 영문이다.
      containerAriaLabel="알림"
      // 기본 토스트 색은 Sonner 변수로, 그림자는 shadow-lg! 로 — v4 유틸리티는 레이어 안이라 Sonner 의 레이어 없는 [data-styled] 규칙에 져 bg·text·border 클래스는 죽은 클래스라 뺐다(설명·버튼 색은 v3 에서도 Sonner 가 이겼다).
      style={
        {
          "--normal-bg": "hsl(var(--background-default))",
          "--normal-text": "hsl(var(--foreground))",
          "--normal-border": "hsl(var(--border))",
        } as React.CSSProperties
      }
      toastOptions={{
        closeButtonAriaLabel: "알림 닫기",
        classNames: {
          // 본체는 클릭 통과(머리 버튼 줄을 덮어 클릭을 먹었다), 버튼·링크만 받는다 — 본체 호버로 타이머 멈춤·스와이프 닫기는 잃는다.
          toast:
            "group toast group-[.toaster]:shadow-lg! pointer-events-none! [&_a]:pointer-events-auto! [&_button]:pointer-events-auto!",
          description: "group-[.toast]:text-muted-foreground whitespace-pre-line",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      richColors
      {...props}
    />
  );
};

export { Toaster };
